import { COMING_SOON_IMAGE } from '@common/utils';

import './slab-icon.scss';

export interface SlabIconProps {
    src: string;
}

function SlabIcon({ src }: SlabIconProps): React.ReactElement {
    const styleProp = {
        backgroundImage: `url(${src}), url(${COMING_SOON_IMAGE})`,
    };
    return <div className="slab-icon__container" style={styleProp} />;
}

export default SlabIcon;
